import WidgetContainer, { IWidgetContainer } from '../WidgetContainer';
import { boxShadow2 } from '../../theme';
import { mergeSX } from '../../services/helpers';
import { encodedCursorSvg } from '../EditableContainer/cursorIcon';

// eslint-disable-next-line max-len
const defaultLinearGradient = 'linear-gradient(45deg, #f9fcff 16%, #ffffff00 16%, #ffffff00 75%, #ebf3fb 75%), linear-gradient(135deg, #ffffff 77%, #f7fbff 77%)';

// eslint-disable-next-line max-len
const hoveredLinearGradient = 'linear-gradient(45deg, #e7f1fd 16%, #eaf3fd 16%, #ffffff00 75%, #dbe9fa 75%), linear-gradient(135deg, #eaf3fd 77%, #e7f1fd 77%)';

const defaultSX = {
  boxShadow: boxShadow2,
  background: defaultLinearGradient,
};

const editableSX = {
  ...defaultSX,
  '&:hover': {
    background: hoveredLinearGradient,
    cursor: `url("${encodedCursorSvg}") 16 16, pointer`,
  },
};

const buildSX = ({ editable }: IBuildSXParams) => (editable ? editableSX : defaultSX);

interface IBuildSXParams {
  editable: boolean;
}

interface IEntityDetailsContainer extends IWidgetContainer {
  editable?: boolean;
}

const EntityDetailsContainer = (props: IEntityDetailsContainer) => {
  const {
    children, sx, editable = false, onClick, ...rest
  } = props;

  return (
    <WidgetContainer
      p={3}
      onClick={editable ? onClick : undefined}
      sx={mergeSX(buildSX({ editable }), sx)}
      {...rest}
    >
      {children}
    </WidgetContainer>
  );
};

export default EntityDetailsContainer;
